import '../bulbs-public-ads-manager/src/prebid-load';
const adsManager = require('../bulbs-public-ads-manager/src/manager.compiled').init({
	adUnits: {
		pbjsSizeConfig: [
			{
				mediaQuery: '(min-width: 0px) and (max-width: 1019px)',
				labels: ['mobile']
			},
			{
				mediaQuery: '(min-width: 1020px)',
				labels: ['desktop']
			}
		],
		units: {

			'mid_banner': {
				'eagerLoad': false,
				'slotName': 'mid_banner',
				'pos': 'mid_banner',
				'sizes': [
					[[1020, 0], [[970, 250], [728, 90]]],
					[[0, 0], [[300, 250]]]
				],
				prebid: {
					'bids': [
						{ 'bidder': 'ix', 'params': { 'siteId': '189612', 'size': [728, 90] }, 'labelAll': ['desktop'] },
						{ 'bidder': 'ix', 'params': { 'siteId': '189613', 'size': [970, 250] }, 'labelAll': ['desktop'] },
						{ 'bidder': 'rubicon', 'params': { 'siteId': '243714', 'zoneId': '1362002', 'accountId': '12156' }, 'labelAll': ['desktop'] },
						{ 'bidder': 'aol', 'params': { 'network': '10434.1', 'placement': '4762277' }, 'labelAll': ['desktop'] },
						{ 'bidder': 'aol', 'params': { 'network': '10434.1', 'placement': '4762280' }, 'labelAll': ['desktop'] },
						{ 'bidder': 'criteo', 'params': { 'networkId': '1482' }, 'labelAll': ['desktop'] },
						{ 'bidder': 'ix', 'params': { 'siteId': '315708', 'size': [300, 250] }, 'labelAll': ['mobile'] },
						{ 'bidder': 'rubicon', 'params': { 'siteId': '115258', 'zoneId': '542924' }, 'labelAll': ['mobile'] },
						{ 'bidder': 'aol', 'params': { 'network': '10434.1', 'placement': '5006027' }, 'labelAll': ['mobile'] },
						{ 'bidder': 'criteo', 'params': { 'networkId': '1482' }, 'labelAll': ['mobile'] },
						{ 'bidder': 'kargo', 'params': { 'placementId': '02ebc842-98f6-4f54-be85-3182d4be7b44' }, 'labelAll': ['mobile'] }
					]
				}
			},
			'mid_banner_eagerload': {
				'eagerLoad': true,
				'slotName': 'mid_banner',
				'pos': 'mid_banner',
				'sizes': [
					[[1020, 0], [[970, 250], [728, 90]]],
					[[0, 0], [[300, 250]]]
				],
				prebid: {
					'bids': [
						{ 'bidder': 'ix', 'params': { 'siteId': '189612', 'size': [728, 90] }, 'labelAll': ['desktop'] },
						{ 'bidder': 'ix', 'params': { 'siteId': '189613', 'size': [970, 250] }, 'labelAll': ['desktop'] },
						{ 'bidder': 'rubicon', 'params': { 'siteId': '243714', 'zoneId': '1362002', 'accountId': '12156' }, 'labelAll': ['desktop'] },
						{ 'bidder': 'aol', 'params': { 'network': '10434.1', 'placement': '4762277' }, 'labelAll': ['desktop'] },
						{ 'bidder': 'aol', 'params': { 'network': '10434.1', 'placement': '4762280' }, 'labelAll': ['desktop'] },
						{ 'bidder': 'criteo', 'params': { 'networkId': '1482' }, 'labelAll': ['desktop'] },
						{ 'bidder': 'ix', 'params': { 'siteId': '315708', 'size': [300, 250] }, 'labelAll': ['mobile'] },
						{ 'bidder': 'rubicon', 'params': { 'siteId': '115258', 'zoneId': '542924' }, 'labelAll': ['mobile'] },
						{ 'bidder': 'aol', 'params': { 'network': '10434.1', 'placement': '5006027' }, 'labelAll': ['mobile'] },
						{ 'bidder': 'criteo', 'params': { 'networkId': '1482' }, 'labelAll': ['mobile'] },
						{ 'bidder': 'kargo', 'params': { 'placementId': '02ebc842-98f6-4f54-be85-3182d4be7b44' }, 'labelAll': ['mobile'] }
					]
				}
			}
		}
	},
	amazonEnabled: true,
	iasEnabled: true,
	dfpId: 4246,
	dfpSiteCode: 'fmg.theroot',
	doReloadOnResize: false,
	prebidEnabled: true
});

window.TARGETING = {
	// forcedadzone: 'nope'
};

window.BULBS_ELEMENTS_ADS_MANAGER = adsManager;



// WEBPACK FOOTER //
// ./theroot/root-100-2019/src/ads.js